import styled from '@emotion/styled';
import BaseTooltip from '@mui/material/Tooltip';

import { greyish } from '~/styles';

export const Heading = styled.h3`
  line-height: 25px;
  font-size: 19px;
  font-weight: 300;
  letter-spacing: 0.25px;
  color: ${greyish};
  z-index: 1;
  margin: 0;
`;

export const Author = styled.div`
  z-index: 1;
  display: flex;
  align-items: center;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  flex: 1;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Tooltip = styled(BaseTooltip)`
  z-index: 1;
`;
